import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export const useHeader = () => {
  const navigate = useNavigate();
  const { logout: authLogout, userName } = useAuth();

  const handleLogout = () => {
    authLogout();
    navigate("/login");
    toast.success("Вы вышли из аккаунта");
  };

  return { handleLogout, userName };
};
